var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"html-block-full-width-overflow",attrs:{"fluid":""}},[_c('b-container',[_c('b-row',[_c('b-col',[_vm._v("\n        Become the most recognized and valuable domestic brand.\n      ")]),_vm._v(" "),_c('b-col',[_vm._v("\n        Background Image Goes Here!\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e19d9c30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./core/vue/components/HTMLBlock1.vue
// module id = 472
// module chunks = 16 17 18 19 20 21 22